export default __webpack_public_path__ + "b8700151af47cd94d3cc0e38d548f09b.svg";